import { preloadPersonalSpaceDetail } from '@confluence/space-utils/entry-points';
import { preloadIntentBasedOnboarding } from '@confluence/home/entry-points/preloadIntentBasedOnboarding';
import { preloadHome } from '@confluence/home/entry-points/preloadHome';
import { preloadCreateFromTemplate } from '@confluence/home/entry-points/preloadCreateFromTemplate';
import { preloadTemplatesCollectionEligible } from '@confluence/home/entry-points/preloadTemplatesCollectionEligible';
import { getPreloaderFnContext } from '@confluence/query-preloader-tools';
import { preloadPostOfficeConfluenceHomeBanner } from '@confluence/experiment-post-office-home-banner/entry-points/preloadConfuenceHomeBanner';
import type { RouteMatch } from '@confluence/route';
import { fg } from '@confluence/feature-gating';

export const preloadHomeRoute = async (match: RouteMatch) => {
	const preloadedSessionContext = await getPreloaderFnContext();
	const { featureFlags, userId, cloudId, isLicensed, accessStatus } = preloadedSessionContext;

	const tasks: Promise<any>[] = [];

	const canAccessHome =
		accessStatus !== 'ANONYMOUS_ACCESS' && accessStatus !== 'UNLICENSED_AUTHENTICATED_ACCESS';

	if (isLicensed && canAccessHome) {
		tasks.push(
			preloadHome({
				cloudId,
				isLicensed,
				userId,
				matchParams: match.params,
				isSpaceAliasFFEnabled: Boolean(featureFlags['confluence.frontend.space.alias']),
				isWhiteboardViewedEnabled: Boolean(featureFlags['confluence.frontend.whiteboard.enable']),
				isDatabaseEnabled: Boolean(featureFlags['confluence.frontend.databases.enabled']),
			}),
		);
	}

	tasks.push(preloadPersonalSpaceDetail());

	if (userId) {
		tasks.push(preloadIntentBasedOnboarding());
		if (fg('confluence_frontend_templates_query_migration')) {
			tasks.push(preloadTemplatesCollectionEligible());
		} else {
			tasks.push(preloadCreateFromTemplate());
		}
	}

	if (userId && fg('post-office-shadow-rollout-confluence-home-ssr')) {
		// Shadow rollout for Confluence Home Banner in SSR only.
		// This should not block any existing SSR steps, and will just run in the background as a promise
		// to allow the Post Office team to gather metrics on our API response time.
		preloadPostOfficeConfluenceHomeBanner(preloadedSessionContext);
	}

	return Promise.all(tasks);
};
